import type { AgentMessageUserValidation } from "@alaffia-technology-solutions/schema";

import { badgeStatusVariants } from "@alaffia-technology-solutions/ds";
import { cn } from "@alaffia-technology-solutions/tailwind-utils";

import { Check } from "lucide-react";

interface UserValidationStatusProps {
  userValidation?: AgentMessageUserValidation | null;
}

export const UserValidationStatus = ({
  userValidation,
}: UserValidationStatusProps) => {
  if (userValidation?.status === "ACCEPTED") {
    return <BadgeAccepted />;
  }

  return null;
};

function BadgeAccepted() {
  return (
    <div
      className={cn(
        badgeStatusVariants({ variant: "success" }),
        "af-border af-border-success-foreground/30 af-bg-success af-text-success-foreground",
      )}
    >
      <Check strokeWidth={3} className="af-h-3 af-w-3" /> Accepted
    </div>
  );
}
